<script setup lang="ts">
import {reactive} from "vue";
import ItemV3StonesStoneSize from "@/components/itemV3/parameter/stones/parameter/itemV3StonesStoneSize.vue";
import ItemV3StonesQuality from "@/components/itemV3/parameter/stones/parameter/itemV3StonesQuality.vue";
import ItemV3StonesPresets from "@/components/itemV3/parameter/stones/parameter/itemV3StonesPresets.vue";

const props = defineProps<{ groupIdx: number }>();
const emit = defineEmits(["patch"]);

/**
 * headlines - collapsible sections (transferred from itemV3Grooves.vue's
 * "groove details - collapsible sections")
 */

const openSections = reactive<Record<string, boolean>>({
  presets: true,
  quality: false,
  stone_size: false,
})

const toggleSection = (key: string) => {
  openSections[key] = !openSections[key]
}

</script>

<template>
  <div class="w-full">

    <div class="w-full">
      <!-- Bibliothek - stones.stone_presets -->
      <button
          type="button"
          class="flex w-full items-center gap-3 mb-3 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]"
          :aria-expanded="openSections.presets"
          @click="toggleSection('presets')"
      >
        <span class="h-px flex-1 bg-[#e7ddcc]"></span>
        <span
            class="flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap">
          Bibliothek
          <svg aria-hidden="true" viewBox="0 0 12 12" fill="none"
               class="size-2.5 shrink-0 text-[#555956] transition-transform"
               :class="openSections.presets ? 'rotate-180' : ''">
            <path d="m1.5 4 4.5 4 4.5-4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span class="h-px flex-1 bg-[#e7ddcc]"></span>
      </button>
      <item-v3-stones-presets
          v-if="openSections.presets"
          class="w-full"
          :show=true
          stone-layout="starry_sky"
          stone-tag=""
          @patch="(event) => emit('patch', event)"
      />
    </div>

    <div class="w-full">
      <!-- Steinart/Qualität - stones.*.stone_type/stone_quality -->
      <button
          type="button"
          class="flex w-full items-center gap-3 mb-3 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]"
          :aria-expanded="openSections.quality"
          @click="toggleSection('quality')"
      >
        <span class="h-px flex-1 bg-[#e7ddcc]"></span>
        <span
            class="flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap">
          Steinart/Qualität
          <svg aria-hidden="true" viewBox="0 0 12 12" fill="none"
               class="size-2.5 shrink-0 text-[#555956] transition-transform"
               :class="openSections.quality ? 'rotate-180' : ''">
            <path d="m1.5 4 4.5 4 4.5-4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span class="h-px flex-1 bg-[#e7ddcc]"></span>
      </button>
      <item-v3-stones-quality
          v-if="openSections.quality"
          class="w-full"
          :group-idx="props.groupIdx" @patch="(event) => emit('patch', event)"/>
    </div>

    <div class="w-full">
        <!-- steingröße - stones.*.stone_size -->
        <button
            type="button"
            class="flex w-full items-center gap-3 mb-3 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]"
            :aria-expanded="openSections.stone_size"
            @click="toggleSection('stone_size')"
        >
          <span class="h-px flex-1 bg-[#e7ddcc]"></span>
          <span
              class="flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap">
            Steingröße
            <svg aria-hidden="true" viewBox="0 0 12 12" fill="none"
                 class="size-2.5 shrink-0 text-[#555956] transition-transform"
                 :class="openSections.stone_size ? 'rotate-180' : ''">
              <path d="m1.5 4 4.5 4 4.5-4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="h-px flex-1 bg-[#e7ddcc]"></span>
        </button>
        <item-v3-stones-stone-size
            v-if="openSections.stone_size"
            class="w-full"
            :group-idx="props.groupIdx" @patch="(event) => emit('patch', event)"/>
    </div>
  </div>
</template>

<style scoped>
</style>
